import React, { useEffect, useState } from 'react';
import FollowUpForm from '@app/components/apps/FollowUp/FollowUpForm';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { Col, Row } from 'antd';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

const CreateFollowUp: React.FC = () => {
  const [currentBreadcrumbName, setCurrentBreadcrumbName] = useState<string>('Add Follow-Up');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/follow-ups',
      breadcrumbName: 'Follow-Ups',
    },
    {
      path: '/add-follow-up',
      breadcrumbName: currentBreadcrumbName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumbName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FollowUpForm
            type="create"
            setCurrentBreadcrumName={setCurrentBreadcrumbName}
            pageTitle={'Create Follow-Up'}
            editable={true}
            id={undefined}
          />
        </Col>
      </Row>
    </>
  );
};

export default CreateFollowUp;
